import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer className="rf-footer mt-auto">
      <div className="max-w-[1140px] mx-auto px-5 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 text-sm">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <img src={require('../img/rakfort.jpg')} alt="" className="h-9 w-9 rounded-sm" />
              <span className="font-semibold text-[#2c2c2c]">RakFort</span>
            </div>
            <p className="text-[#5c5c5c] max-w-md leading-relaxed">
              AI security, governance, and specialist talent acquisition for high-stakes industries. We help
              organisations assess risk, govern models, protect AI in production, and place the expert teams
              to sustain it.
            </p>
            <p className="mt-2 text-[#5c6d7e] text-xs max-w-md">
              From AI strategy to secure deployment — we make your AI work, and work safely.
            </p>
          </div>
          <div>
            <p className="font-medium text-[#2c2c2c] mb-3">Explore</p>
            <ul className="space-y-2 text-[#5c5c5c]">
              <li>
                <Link to="/services" className="hover:text-[#005a9c]">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/solutions/ai-security" className="hover:text-[#005a9c]">
                  Solutions
                </Link>
              </li>
              <li>
                <Link to="/research" className="hover:text-[#005a9c]">
                  Research
                </Link>
              </li>
              <li>
                <Link to="/use-cases" className="hover:text-[#005a9c]">
                  Use cases
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <p className="font-medium text-[#2c2c2c] mb-3">Legal</p>
            <ul className="space-y-2 text-[#5c5c5c]">
              <li>
                <Link to="/contactus" className="hover:text-[#005a9c]">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/privacypolicy" className="hover:text-[#005a9c]">
                  Privacy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-[#005a9c]">
                  Terms
                </Link>
              </li>
              <li>
                <Link to="/cookiepolicy" className="hover:text-[#005a9c]">
                  Cookies
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <p className="mt-10 pt-8 border-t border-[#e8e8e8] text-xs text-[#737373]">
          © {new Date().getFullYear()} RakFort. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
